module.exports = __webpack_public_path__ + "img/line-awesome.131b7f1.svg";